import { SegmentController } from "components/designV2/segmentcontroller/segmentcontroller";
import { useTranslation } from "react-i18next";
import type { ProfilePanelTab } from "../profilePanel.contract";
import { TabsRow } from "./profilePanel.styled";

interface ProfilePanelTabsProps {
  value: ProfilePanelTab;
  onChange: (value: string) => void;
}

/**
 * Handles profile panel tabs.
 */
export const ProfilePanelTabs = (props: ProfilePanelTabsProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <TabsRow>
      <SegmentController
        options={[
          {
            value: "profile",
            label: t("Staff.ProfilePanelTabProfile"),
          },
          {
            value: "employmentSalary",
            label: t("Staff.ProfilePanelTabEmploymentSalary"),
          },
          {
            value: "history",
            label: t("General.History"),
          },
        ]}
        value={props.value}
        onChange={props.onChange}
      />
    </TabsRow>
  );
};
